/**
 * Constants for the different types of general placeholders
 * @type {{OTHER: string, FL: string, ELECTIVE: string, STUDYABROAD: string}}
 */

import GenEdUtils from "./GenEdUtils";

// TODO: For now the values are hard-coded but we need a Rest api to get these values from the database
export const GeneralPlaceholders = {
    ELECTIVE: "uw.academicplan.placeholder.elective|uw.academicplan.placeholder",
    STUDYABROAD: "uw.academicplan.placeholder.studyabroad|uw.academicplan.placeholder",
    // this does not exist in the db and is only used by the react app to display genedrequirements
    GENERALEDUCATION: "uw.academicplan.placeholder.generaleducation|uw.academicplan.placeholder",
    FL: "uw.academicplan.placeholder.foreignlanguage|uw.academicplan.placeholder",
    OTHER: "uw.academicplan.placeholder.other|uw.academicplan.placeholder"
};

export const getGeneralPlaceholderName = (code, value, showOther = true) => {
    // We read the abbreviated value as the code for the general placeholders at the backend which are not standardized values
    // eg: for Study Abroad and some others the abbr value is 'Study Abroad' but for Foreign language its 'FL' so we need to do this extra check
    if ( code.toUpperCase() === "OTHER" || code.toUpperCase() === "FL" ) {
        if ( code.toUpperCase() === "OTHER") {
            // For cases where we dont want to show the custom other title, return nothing
            // This is the case for modal buttons as to not allow long, layout breaking, button names
            return (showOther ? value : "");
        } else {
            return value
        }
    } else {
        return code;
    }
};

// Get a description of a placeholder from its code, course level placeholder (e.g. MATH 1xx) will simply be returned as there is not a code
export const getPlaceholderDescriptionFromCode = (code) => {
    if (code.includes("|")) {
        let generalPlaceholders = {
            "uw.academicplan.placeholder.elective|uw.academicplan.placeholder": "Elective",
            "uw.academicplan.placeholder.studyabroad|uw.academicplan.placeholder": "Study Abroad",
            "uw.academicplan.placeholder.generaleducation|uw.academicplan.placeholder": "General Education Req",
            "uw.academicplan.placeholder.foreignlanguage|uw.academicplan.placeholder": "Foreign Language",
            "uw.academicplan.placeholder.other|uw.academicplan.placeholder": "Other"
        };

        // Get the list of gen eds and build a map where code is the key and description is the value
        let genEduReqs = {};
        for (let i = 0; i < GenEdUtils.list.length; i++) {
            genEduReqs[GenEdUtils.list[i].genedCode] = GenEdUtils.list[i].title;
        }

        // Merge both the general placeholders and gen eds
        const placeholderMap = Object.assign(generalPlaceholders, genEduReqs);

        // Check the map for the given code
        if (placeholderMap.hasOwnProperty(code.toLowerCase())) {
            // return the description for the given code
            return placeholderMap[code];
        } else {
            return "";
        }
    } else {
        // A course level placeholder code was passed, return the same value, e.g. MATH 1xx
        return code;
    }
};